


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import qs from 'qs';
@Component<VBANNER>({
  components: {
    dialogComp,
  },
})
export default class VBANNER extends Vue {
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public callback() {}
}
